import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

export const getCmsContents = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/cms-contents`);
        return response.data;
    } catch (error) {
        console.error('Error fetching CMS contents:', error);
        throw error;
    }
};

export const createCmsContent = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/cms-contents`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating CMS content:', error);
        throw error;
    }
};

export const updateCmsContent = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/cms-contents/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating CMS content:', error);
        throw error;
    }
};

export const getCmsByType = async (type) => {
    try {
        const response = await axios.get(`${apiUrlOne}/cms-contents/type/${type}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching CMS content for type ${type}:`, error);
        throw error;
    }
};